import AuthWrapper from "@/layouts/AuthWrapper";
import { Box, Flex, Text } from "@chakra-ui/react";
import Button from "@/components/common/Button";
import { useNavigate } from "react-router-dom";
import CheckIcon from "@/assets/svg/check-stroke.svg?react";
import CustomCard from "@/components/common/CustomCard";
import { NAVIGATION_ROUTES } from "@/routes/constants";

const RegistrationSuccess = () => {
  const navigate = useNavigate();
  return (
    <Box id="registration-success" fontFamily={"primary"}>
      <AuthWrapper>
        <Flex
          px={"20px"}
          maxWidth={"400px"}
          direction="column"
          align="start"
          justify="center"
          gap={8}
        >
          <CustomCard p="3">
            <CheckIcon />
          </CustomCard>
          <Flex direction="column" align="start" gap={2}>
            <Text fontSize="4xl" fontWeight="semibold">
              Registration Successful
            </Text>
            <Text fontSize="sm" color="gray.500">
              Your account has been successfully registered. You can now log in
              to your account.
            </Text>
          </Flex>
          <Button
            onClick={() => {
              navigate(NAVIGATION_ROUTES.SIGNIN);
            }}
            width={"full"}
            fontSize={"md"}
          >
            Get Started
          </Button>
        </Flex>
      </AuthWrapper>
    </Box>
  );
};

export default RegistrationSuccess;
